// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switch-button[data-v-31b4912e]{width:82px;height:82px;border:3px solid #fff;background:hsla(0,0%,100%,.2) 0 0 no-repeat padding-box;opacity:1}.switch-button__left[data-v-31b4912e]{position:absolute;right:190px}.switch-button__middle[data-v-31b4912e]{position:absolute;right:95px}.switch-button__right[data-v-31b4912e]{position:absolute;right:0}", ""]);
// Exports
module.exports = exports;
